import { Descriptions } from "antd";

export default function EDescription({
  children,
  title,
  layout = "vertical",
  bordered = false,
  column = 2,
  colon = "",
  size = "small",
}) {
  return (
    <Descriptions title={title} layout={layout} column={column} colon={colon} bordered={bordered} size={size}>
      {children}
    </Descriptions>
  );
}
